import { render, staticRenderFns } from "./ScheduledPacking.vue?vue&type=template&id=52232489&"
import script from "./ScheduledPacking.vue?vue&type=script&lang=js&"
export * from "./ScheduledPacking.vue?vue&type=script&lang=js&"
import style0 from "./ScheduledPacking.vue?vue&type=style&index=0&id=52232489&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports